/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.documents.MountAccess
*/
export var MountAccess;
(function (MountAccess) {
    MountAccess["UNKNOWN"] = "UNKNOWN";
    MountAccess["RO"] = "RO";
    MountAccess["RW"] = "RW";
})(MountAccess || (MountAccess = {}));
//# sourceMappingURL=MountAccess.js.map